import { dom } from '@fortawesome/fontawesome-svg-core'
;(async () => {
  const { default: moment } = await import('moment')

  Promise.all([
    import(/* webpackMode: "eager" */ './see-and-do-listing.scss'),
    import('../../plugins/semantic/popup'),
    import('../../plugins/semantic/table.css'),
    import('../../plugins/semantic/icon.css'),
    import('../../plugins/semantic/checkbox.css'),
    import('../../plugins/semantic/checkbox'),
    import('../../plugins/semantic/popup.css'),
    import('../../scripts/dbs/dbs.utilities.querystring'),
    import('../../plugins/semantic-calendar/calendar'),
    import('../../plugins/semantic-calendar/calendar.css'),
    import('../../plugins/semantic/form.scss'),
  ]).then(() => {
    $('.widget.see-and-do-listing').each(function (i, el) {
      $(el).data('widget', new SeeAndDoListing(el, moment))
      $(el).data('widget').init()
    })
  })
})()

function SeeAndDoListing(el, moment) {
  const self = this
  self.el = $(el)

  self.activityListingTemplate = require('./see-and-do-listing.hbs')
  self.totalCount = 0
  self.offset = 0
  self.pageSize = 0

  self.qs = new dbs.utilities.querystring()

  self.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  self.today = new Date()
  self.maxDate = new moment().add(1, 'y').toDate()

  self.search = function (clear, disableHistory) {
    self.el.find('.load-more-container').hide()

    let filters = {
      location: null,
      type: null,
      from: null,
      to: null,
      today: moment(self.today).format('YYYY-MM-DD'),
    }

    if (self.el.find('.filters .filter-set[data-category="location"] input:checked').length) {
      filters.location = []
      self.el.find('.filters .filter-set[data-category="location"] input:checked').each(function (i, el) {
        filters.location.push($(el).val())
      })
    }

    if (self.el.find('.filters .filter-set[data-category="type"] input:checked').length) {
      filters.type = []
      self.el.find('.filters .filter-set[data-category="type"] input:checked').each(function (i, el) {
        filters.type.push($(el).val())
      })
    }

    if (self.el.find('.from-calendar input').val().length) {
      filters.from = moment(self.el.find('.from-calendar input').val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (self.el.find('.to-calendar input').val().length) {
      filters.to = moment(self.el.find('.to-calendar input').val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (!disableHistory) {
      let stateFilters = {}

      if (filters.location) {
        stateFilters.location = filters.location.join(',')
      }

      if (filters.type) {
        stateFilters.type = filters.type.join(',')
      }

      if (filters.from) {
        stateFilters.from = filters.from
      }

      if (filters.to) {
        stateFilters.to = filters.to
      }

      self.activityFiltersPushState(stateFilters)
    }

    // send filters to ajax
    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(filters),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        if (data.States) {
          for (let s = 0; s < data.States.length; s++) {
            const state = data.States[s]
            for (let g = 0; g < state.Groups.length; g++) {
              const group = state.Groups[g]
              for (let a = 0; a < group.Activities.length; a++) {
                const activity = group.Activities[a]
                activity.DatesMatch = activity.StartDate === activity.EndDate

                if (activity.StartDate && !activity.EndDate) {
                  activity.StartOnly = true
                }

                if (activity.EndDate && !activity.StartDate) {
                  activity.EndOnly = true
                }

                if (activity.EndDate && activity.StartDate) {
                  activity.BothDates = true
                }
              }
            }
          }
        }

        // if clear true delete
        if (clear) {
          self.el.find('.results .articles, .results .message').remove()
        }

        const html = self.activityListingTemplate({
          data: data,
        })
        self.el.find('.results').html(html)

        if (data.Message && data.Message.length) {
          self.el.find('.results').html('<div class="ui message">' + data.Message + '</div>')
        }
      })
      .fail(function (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error('see and do fail', err)
        }
        // TODO decide what happens on fail
      })
      .always(function () {
        // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
        dom.i2svg()
      })
  }

  self.formatDate = function (date) {
    if (!date) return ''
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    return (
      (day.toString().length === 1 ? '0' + day : day) +
      '/' +
      (month.toString().length === 1 ? '0' + month : month) +
      '/' +
      year
    )
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('SeeAndDoListing init', self)
    }
    self.el.css('opacity', 1)

    self.el.find('.ui.checkbox').checkbox()

    $('body').on('click', '.activities .activity .terms .expander', function (e) {
      e.preventDefault()
      $(this).slideUp()
      $(this).siblings('.content').slideDown()
      $(this).siblings('.contracter').slideDown()
    })

    $('body').on('click', '.activities .activity .terms .contracter', function (e) {
      e.preventDefault()
      $(this).slideUp()
      $(this).siblings('.content').slideUp()
      $(this).siblings('.expander').slideDown()
    })

    self.el.find('.from-calendar').calendar({
      type: 'date',
      minDate: self.today,
      maxDate: self.maxDate,
      endCalendar: $('.to-calendar'),
      popupOptions: {
        position: 'bottom left',
        lastResort: 'bottom left',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.from-mobile-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })
    self.el.find('.to-calendar').calendar({
      type: 'date',
      startCalendar: $('.from-calendar'),
      minDate: self.tomorrow,
      maxDate: self.maxDate,
      popupOptions: {
        position: 'bottom left',
        lastResort: 'bottom left',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.to-mobile-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })

    self.el.find('.from-mobile-calendar').calendar({
      type: 'date',
      minDate: self.today,
      maxDate: self.maxDate,
      endCalendar: $('.to-mobile-calendar'),
      popupOptions: {
        position: 'bottom left',
        lastResort: 'bottom left',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.from-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })
    self.el.find('.to-mobile-calendar').calendar({
      type: 'date',
      startCalendar: $('.from-mobile-calendar'),
      minDate: self.tomorrow,
      maxDate: self.maxDate,
      popupOptions: {
        position: 'bottom right',
        lastResort: 'bottom right',
        prefer: 'opposite',
        hideOnScroll: false,
      },
      formatter: {
        // eslint-disable-next-line no-unused-vars
        date: function (date, settings) {
          return self.formatDate(date)
        },
      },
      parser: {
        // eslint-disable-next-line no-unused-vars
        date: function (text, settings) {
          return new moment(text, 'DD/MM/YYYY').toDate()
        },
      },
      // eslint-disable-next-line no-unused-vars
      onChange: function (date, text, mode) {
        if (!self.statePopped) {
          self.el.find('.to-calendar').calendar('set date', date, true, false)
          setTimeout(function () {
            self.search()
          }, 300)
        }
      },
    })

    // SYNC
    self.el.find('.mobile-filters input[type="checkbox"]').on('change', function () {
      self.el.find('.filters input[type="checkbox"]').prop('checked', false)

      // sync with mobile checkboxes
      self.el.find('.mobile-filters input[type="checkbox"]').each(function (i, el) {
        if ($(el).is(':checked')) {
          self.el.find('.filters input[value="' + $(el).attr('value') + '"]').prop('checked', true)
        }
      })

      self.offset = 0
      self.search(true)
    })

    self.el.find('.filters input[type="checkbox"]').on('change', function () {
      self.el.find('.mobile-filters input[type="checkbox"]').prop('checked', false)

      // sync with desktop checkboxes
      self.el.find('.filters input[type="checkbox"]').each(function (i, el) {
        if ($(el).is(':checked')) {
          self.el.find('.mobile-filters input[value="' + $(el).attr('value') + '"]').prop('checked', true)
        }
      })

      self.offset = 0
      self.search(true)
    })

    self.statePopped = false

    // handle popstate
    window.onpopstate = function (event) {
      self.statePopped = true

      // window.dbs.globalEvents.emit('search_popstate', event.state);
      self.setFiltersFromUrl()

      if (event.state) {
        self.search(true, true)
      }

      self.statePopped = false
    }

    self.loadMore = function () {
      self.offset = self.offset + self.pageSize
      self.search(false, true)
    }

    self.el.find('.mobile-filters .state-filter').popup({
      popup: self.el.find('.mobile-state-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.mobile-filters .type-filter').popup({
      popup: self.el.find('.mobile-type-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.mobile-filters .date-filter').popup({
      popup: self.el.find('.mobile-date-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.clear-filters').click(function (event) {
      event.preventDefault()
      self.el.find('.filters input[type="checkbox"], .mobile-filters input[type="checkbox"]').prop('checked', false)
      self.el.find('.ui.calendar').calendar('clear')
      self.offset = 0
      self.search(true)
      self.el.find('.mobile-filters .state-filter').html('State')
      self.el.find('.mobile-filters .type-filter').html('Type')
    })

    self.setFiltersFromUrl()
    self.search(true, true)
  }

  self.activityFiltersPushState = function (filters) {
    // create a state object with all filters
    let url = window.location.pathname.replace(/\/+/g, '/')
    history.pushState({ filters: filters }, $(' head title').html(), url + '?' + $.param(filters))
  }

  self.setFiltersFromUrl = function () {
    self.statePopped = true
    self.location = self.qs.getParameter('location')
    self.type = self.qs.getParameter('type')
    self.from = self.qs.getParameter('from')
    self.to = self.qs.getParameter('to')

    // clear all filters
    self.el.find('.filters input[type="checkbox"]').prop('checked', false)
    self.el.find('.mobile-filters input[type="checkbox"]').prop('checked', false)
    self.el.find('.ui.calendar').calendar('clear')

    if (self.location) {
      const locationArray = self.location.split(',')
      for (let i = 0; i < locationArray.length; i++) {
        const locationArrayElement = locationArray[i]
        self.el.find('input[value="' + locationArrayElement + '"]').prop('checked', true)
        // self.el.find('.mobile-filters .state-filter').html(locationArrayElement);
      }
    }

    if (self.type) {
      const typeArray = self.type.split(',')
      for (let i = 0; i < typeArray.length; i++) {
        const typeArrayElement = typeArray[i]
        self.el.find('input[value="' + typeArrayElement + '"]').prop('checked', true)
        // self.el.find('.mobile-filters .type-filter').html(typeArrayElement);
      }
    }

    if (self.from) {
      self.el.find('.from-calendar').calendar('set date', moment(self.from, 'YYYY-MM-DD').toDate(), true, false)
    }

    if (self.to) {
      self.el.find('.to-calendar').calendar('set date', moment(self.to, 'YYYY-MM-DD').toDate(), true, false)
    }

    self.statePopped = false
  }
}
